export const ConsentText = ({ consent }) => (
  <>
    {consent.textBefore}
    {consent.link && (
      <a href={consent.href} target="_blank" rel="noreferrer">
        {consent.link}
      </a>
    )}
    {consent.textAfter}{' '}
    <span className="field__req" aria-hidden="true">
      *
    </span>
  </>
);